import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Modal,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { RxCross1 } from "react-icons/rx";
import { getPrincipalPbf } from "../../../../services/purchaseApi";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalFilterPrincipal = ({ open, setOpen, reqBody, setReqBody }) => {
  const [tempPrincipalArr, setTempPrincipalArr] = useState([]);

  const handleClose = () => {
    setTempPrincipalArr([]);
    setOpen(false);
  };

  const { data: dataPrincipal, isFetching: isFetchingPrincipal } = useQuery({
    queryKey: ["rank-principle", open],
    queryFn: () => getPrincipalPbf(),
    enabled: open === true,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    setTempPrincipalArr(reqBody.principal_ids);
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "hidden",
            overflowX: "wrap",
            maxHeight: "80vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-2/3 h-fit text-[#2C3E5D]"
        >
          <div className="flex justify-between items-center px-8 py-4">
            <p className="text-[18px]">Principal</p>
            <RxCross1
              className="cursor-pointer hover:text-red-500"
              onClick={handleClose}
            />
          </div>
          <div className="px-8 pb-4 overflow-y-auto overflow-x-hidden max-h-[40vh] ">
            {dataPrincipal && !isFetchingPrincipal ? (
              <>
                {dataPrincipal.map((item, i) => (
                  <FormControlLabel
                    sx={{ width: "100%", marginBottom: 1 }}
                    control={<Checkbox value={item.principal_id} />}
                    label={item.principal_name_alias}
                    checked={tempPrincipalArr.includes(item.principal_id)}
                    onChange={() => {
                      const index = tempPrincipalArr.findIndex(
                        (id) => id === item.principal_id
                      );

                      setTempPrincipalArr(
                        index < 0
                          ? [...tempPrincipalArr, item.principal_id]
                          : [
                              ...tempPrincipalArr.slice(0, index),
                              ...tempPrincipalArr.slice(index + 1),
                            ]
                      );
                    }}
                  />
                ))}
              </>
            ) : (
              <CircularProgress size={20} />
            )}
          </div>

          <div className="flex justify-end items-center px-8 py-4 gap-2">
            <button
              type="button"
              className="border-2 py-2 px-4 rounded-md bg-[#F1FAF0] text-[#6F955B] border-[#6F955B] hover:bg-gray-300"
              onClick={handleClose}
            >
              Batal
            </button>
            <button
              type="button"
              className="border-2 py-2 px-4 rounded-md bg-[#6F955B] border-[#6F955B] text-white hover:bg-gray-300"
              onClick={() => {
                setReqBody((prevVal) => ({
                  ...prevVal,
                  principal_ids: tempPrincipalArr,
                  offset: 1,
                }));
                handleClose();
              }}
            >
              Simpan
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ModalFilterPrincipal;
